<template>
  <v-container id="user-profile" fluid tag="section" class=" text_google">
    <!-- Floating Background Shapes -->
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>

    <v-row justify="center" align="center" class="">
      <v-col cols="12">
        <v-card class="login-main-card" elevation="24" rounded="xl">
          <!-- Header Section -->
          <div class="login-header-section">
            <!-- Logo Section -->
            <div class="logo-section text-center">
              <div class="logo-background mx-auto">
                <lord-icon
                  src="https://cdn.lordicon.com/shcfcebj.json"
                  trigger="loop"
                  style="width:80px;height:80px"
                  class="logo-image"
                ></lord-icon>
              </div>
              <div class="login-message mt-4">
                <h1 class="login-title">ระบบเข้าสู่ระบบ</h1>
                <p class="login-subtitle mb-0">ข้าราชการครูและบุคลากรทางการศึกษา</p>
              </div>
            </div>

            <!-- Login Instructions -->
            <div class="login-instructions mt-6">
              <v-row>
                <v-col cols="12" sm="6" class="text-center">
                  <v-chip
                    class="glass-chip ma-1"
                    color="primary"
                    text-color="white"
                    small
                  >
                    <v-icon left small>mdi-account</v-icon>
                    Username: รหัสบัตรประชาชน
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="6" class="text-center">
                  <v-chip
                    class="glass-chip ma-1"
                    color="secondary"
                    text-color="white"
                    small
                  >
                    <v-icon left small>mdi-lock</v-icon>
                    Password: วันเดือนปีเกิด
                  </v-chip>
                </v-col>
              </v-row>
              <div class="text-center mt-2">
                <v-chip class="glass-chip-example" color="info" outlined small>
                  ตัวอย่าง: 8/8/2531
                </v-chip>
              </div>
            </div>
          </div>

          <v-card-text class="pa-8">
            <!-- Login Button -->
            <div class="text-center login-button-section">
              <v-dialog v-model="dialogLogin" persistent max-width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="login-btn"
                    x-large
                    rounded
                    elevation="8"
                    v-bind="attrs"
                    v-on="on"
                    block
                  >
                    <v-icon left size="28">mdi-login-variant</v-icon>
                    เข้าสู่ระบบ
                    <v-icon right size="28">mdi-account-circle</v-icon>
                  </v-btn>
                </template>

                <!-- Login Dialog -->
                <v-card class="login-dialog" rounded="xl">
                  <!-- Dialog Header -->
                  <v-card-title class="dialog-header white--text">
                    <div class="dialog-title-content">
                      <div class="dialog-icon-bg">
                        <v-icon size="32" color="white">mdi-account-circle</v-icon>
                      </div>
                      <div class="ml-4">
                        <h3 class="mb-1">เข้าสู่ระบบ</h3>
                        <p class="subtitle mb-0">ข้าราชการครูและบุคลากรทางการศึกษา</p>
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-text class="pa-6">
                    <v-form ref="form" lazy-validation>
                      <v-text-field
                        color="primary"
                        prepend-icon="mdi-account"
                        name="login"
                        label="ชื่อผู้ใช้งาน : รหัสบัตรประชาชน"
                        type="text"
                        v-model="id_card"
                        :rules="[v => !!v || 'กรุณากรอกชื่อผู้ใช้งาน']"
                        rounded
                        outlined
                        class="enhanced-input mb-4"
                      ></v-text-field>

                      <v-text-field
                        color="primary"
                        name="password"
                        label="รหัสผ่าน (วันเดือนปีเกิด)"
                        prepend-icon="mdi-lock-outline"
                        id="password"
                        v-model="p_word"
                        rounded
                        :rules="[v => !!v || 'กรุณากรอกรหัสผ่าน']"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        @click:append="show1 = !show1"
                        outlined
                        class="enhanced-input"
                        hint="ตัวอย่าง: 8/8/2531"
                        persistent-hint
                      ></v-text-field>
                    </v-form>

                    <!-- ลิงก์ลืมรหัสผ่าน -->
                    <div class="text-center mt-3">
                      <v-btn
                        text
                        small
                        color="primary"
                        class="forgot-link"
                        @click="openResetDialog"
                      >
                        <v-icon left small>mdi-lock-question</v-icon>
                        ลืมรหัสผ่าน? คลิกเพื่อรีเซ็ตรหัสผ่าน
                      </v-btn>
                    </div>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="pa-4">
                    <v-btn
                      rounded
                      outlined
                      color="grey"
                      @click="dialogLogin = false"
                      class="cancel-btn"
                    >
                      <v-icon left>mdi-close</v-icon>
                      ยกเลิก
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      rounded
                      large
                      @click="userLogin()"
                      class="submit-btn"
                      elevation="4"
                      :loading="loading"
                    >
                      <v-icon left>mdi-login-variant</v-icon>
                      เข้าสู่ระบบ
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>


          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ========================= Dialog รีเซ็ตรหัสผ่าน ========================= -->
    <v-dialog v-model="dialogReset" persistent max-width="640" scrollable>
      <v-card class="login-dialog" rounded="xl">
        <v-card-title class="dialog-header white--text">
          <div class="dialog-title-content">
            <div class="dialog-icon-bg">
              <v-icon size="32" color="white">mdi-lock-reset</v-icon>
            </div>
            <div class="ml-4">
              <h3 class="mb-1">รีเซ็ตรหัสผ่าน</h3>
              <p class="subtitle mb-0">ยืนยันตัวตนเพื่อรับรหัสผ่านใหม่ทางอีเมล</p>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pa-6" style="max-height: 70vh;">
          <v-alert dense text type="info" border="left" class="mb-4">
            ระบบจะส่งรหัสผ่านใหม่ไปยังอีเมล <strong>Gmail</strong> ที่ท่านระบุเท่านั้น
            กรุณากรอกข้อมูลให้ตรงกับที่ลงทะเบียนไว้
          </v-alert>

          <v-form ref="resetForm" lazy-validation>
            <!-- วิทยาลัยที่สังกัด -->
            <v-autocomplete
              v-model="reset.college_code"
              :items="colleges"
              :loading="collegeLoading"
              item-text="college_name"
              item-value="college_code"
              label="วิทยาลัยที่สังกัด"
              prepend-icon="mdi-office-building"
              :rules="[v => !!v || 'กรุณาเลือกวิทยาลัย']"
              no-data-text="ไม่พบข้อมูลวิทยาลัย"
              rounded
              outlined
              clearable
              class="enhanced-input mb-2"
            ></v-autocomplete>

            <!-- เลขบัตรประชาชน -->
            <v-text-field
              v-model="reset.id_card"
              label="เลขบัตรประชาชน (13 หลัก)"
              prepend-icon="mdi-card-account-details"
              :rules="idCardRules"
              maxlength="13"
              rounded
              outlined
              class="enhanced-input mb-2"
            ></v-text-field>

            <!-- ชื่อ - นามสกุล -->
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="reset.frist_name"
                  label="ชื่อ"
                  prepend-icon="mdi-account"
                  :rules="[v => !!v || 'กรุณากรอกชื่อ']"
                  rounded
                  outlined
                  class="enhanced-input"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="reset.last_name"
                  label="นามสกุล"
                  :rules="[v => !!v || 'กรุณากรอกนามสกุล']"
                  rounded
                  outlined
                  class="enhanced-input"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- วันเดือนปีเกิด -->
            <p class="field-group-label">วัน / เดือน / ปีเกิด</p>
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="reset.brith_day"
                  :items="days"
                  label="วันเกิด"
                  prepend-icon="mdi-calendar"
                  :rules="[v => !!v || 'เลือกวัน']"
                  rounded
                  outlined
                  class="enhanced-input"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="reset.brith_month"
                  :items="months"
                  item-text="text"
                  item-value="value"
                  label="เดือนเกิด"
                  :rules="[v => !!v || 'เลือกเดือน']"
                  rounded
                  outlined
                  class="enhanced-input"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="reset.brith_year"
                  label="ปีเกิด (พ.ศ.)"
                  type="number"
                  hint="เช่น 2531"
                  persistent-hint
                  :rules="yearRules"
                  rounded
                  outlined
                  class="enhanced-input"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>

            <!-- ช่องทางติดต่อ -->
            <p class="field-group-label">ช่องทางติดต่อสำหรับรับรหัสผ่านใหม่</p>
            <v-text-field
              v-model="reset.tel_p"
              label="เบอร์โทรศัพท์"
              prepend-icon="mdi-phone"
              :rules="[v => !!v || 'กรุณากรอกเบอร์โทรศัพท์']"
              rounded
              outlined
              class="enhanced-input mb-2"
            ></v-text-field>

            <v-text-field
              v-model="reset.e_mail"
              label="อีเมล (Gmail เท่านั้น)"
              prepend-icon="mdi-email"
              :rules="emailRules"
              hint="ตัวอย่าง: yourname@gmail.com"
              persistent-hint
              rounded
              outlined
              class="enhanced-input"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-btn
            rounded
            outlined
            color="grey"
            @click="dialogReset = false"
            class="cancel-btn"
          >
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            large
            @click="resetPassword()"
            class="submit-btn"
            elevation="4"
            :loading="resetLoading"
          >
            <v-icon left>mdi-send</v-icon>
            ยืนยันและรับรหัสผ่านใหม่
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar for notifications -->
    <v-snackbar v-model="dialog" top class="enhanced-snackbar" :timeout="snackbar_timeout">
      <div class="white--text">
        <v-icon color="white" left>mdi-information</v-icon>
        {{ dialog_msg }}
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="dialog = false" color="white">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      show1: false,
      dialogLogin: false,
      id_card: "",
      p_word: "",
      dialog: false,
      dialog_msg: "",
      loading: false,
      snackbar_timeout: 10000,
      personnel_etc_id_card: "",
      personnel_etc_pass: "",

      // ===== ส่วนรีเซ็ตรหัสผ่าน =====
      dialogReset: false,
      resetLoading: false,
      collegeLoading: false,
      colleges: [],
      reset: {
        college_code: null,
        id_card: "",
        frist_name: "",
        last_name: "",
        brith_day: null,
        brith_month: null,
        brith_year: "",
        tel_p: "",
        e_mail: ""
      },
      days: Array.from({ length: 31 }, (_, i) => i + 1),
      months: [
        { value: 1, text: "มกราคม" },
        { value: 2, text: "กุมภาพันธ์" },
        { value: 3, text: "มีนาคม" },
        { value: 4, text: "เมษายน" },
        { value: 5, text: "พฤษภาคม" },
        { value: 6, text: "มิถุนายน" },
        { value: 7, text: "กรกฎาคม" },
        { value: 8, text: "สิงหาคม" },
        { value: 9, text: "กันยายน" },
        { value: 10, text: "ตุลาคม" },
        { value: 11, text: "พฤศจิกายน" },
        { value: 12, text: "ธันวาคม" }
      ],
      idCardRules: [
        v => !!v || "กรุณากรอกเลขบัตรประชาชน",
        v => (v && v.length === 13) || "เลขบัตรประชาชนต้องมี 13 หลัก"
      ],
      yearRules: [
        v => !!v || "กรุณากรอกปีเกิด",
        v => (v && String(v).length === 4) || "กรอกปี พ.ศ. 4 หลัก (เช่น 2531)"
      ],
      emailRules: [
        v => !!v || "กรุณากรอกอีเมล",
        v => /^[^@\s]+@gmail\.com$/i.test(v) || "ต้องเป็นอีเมล Gmail (@gmail.com) เท่านั้น"
      ]
    };
  },
  mounted() {
    // Add entrance animation classes
    this.$nextTick(() => {
      const mainCard = document.querySelector('.login-main-card');
      const logoSection = document.querySelector('.logo-section');
      const instructions = document.querySelector('.login-instructions');
      const buttonSection = document.querySelector('.login-button-section');
      const quickStats = document.querySelector('.quick-stats');

      if (mainCard) mainCard.classList.add('fade-in-up');
      if (logoSection) {
        logoSection.style.animationDelay = '0.2s';
        logoSection.classList.add('fade-in-up');
      }
      if (instructions) {
        instructions.style.animationDelay = '0.4s';
        instructions.classList.add('fade-in-up');
      }
      if (buttonSection) {
        buttonSection.style.animationDelay = '0.6s';
        buttonSection.classList.add('fade-in-up');
      }
      if (quickStats) {
        quickStats.style.animationDelay = '0.8s';
        quickStats.classList.add('fade-in-up');
      }
    });
  },
  methods: {
    async userLogin() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let result = await this.$http.post("login.php?crud=user", {
            id_card: this.id_card,
            p_word: this.p_word
          });

          if (result.data.user_status) {
            let user = result.data;
            user.system_lock = false;
            sessionStorage.setItem("user", JSON.stringify(user));

            if (
              user.user_status == "teacher" ||
              user.user_status == "se_director" ||
              user.user_status == "director" ||
              user.user_status == "S" ||
              user.user_status == "38" ||
              user.user_status == "3801" ||
              user.user_status == "3802" ||
              user.user_status == "3803" ||
              user.user_status == "C"
            ) {
              this.dialogLogin = false;
              this.dialog = true;
              this.dialog_msg = "เข้าสู่ระบบสำเร็จ กำลังเปลี่ยนหน้า...";
              setTimeout(() => {
                this.$router.push("/user");
              }, 1500);
            } else {
              sessionStorage.clear();
              this.dialog = true;
              this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
            }
          } else {
            this.dialog = true;
            this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
          }
        } catch (error) {
          this.dialog = true;
          this.dialog_msg = "เกิดข้อผิดพลาดในการเข้าสู่ระบบ";
        } finally {
          this.loading = false;
        }
      }
    },

    // เปิด dialog รีเซ็ตรหัสผ่าน และโหลดรายชื่อวิทยาลัย
    async openResetDialog() {
      this.dialogLogin = false;
      this.dialogReset = true;
      if (this.colleges.length === 0) {
        await this.fetchColleges();
      }
    },

    // โหลดรายชื่อวิทยาลัยสำหรับ dropdown
    async fetchColleges() {
      this.collegeLoading = true;
      try {
        let result = await this.$http.post("reset_password.php?crud=colleges", {});
        if (Array.isArray(result.data)) {
          this.colleges = result.data;
        } else {
          this.dialog = true;
          this.dialog_msg = "ไม่สามารถโหลดรายชื่อวิทยาลัยได้";
        }
      } catch (error) {
        this.dialog = true;
        this.dialog_msg = "ไม่สามารถโหลดรายชื่อวิทยาลัยได้";
      } finally {
        this.collegeLoading = false;
      }
    },

    // ส่งคำขอรีเซ็ตรหัสผ่าน
    async resetPassword() {
      if (this.$refs.resetForm.validate()) {
        this.resetLoading = true;
        try {
          let result = await this.$http.post("reset_password.php?crud=reset", {
            college_code: this.reset.college_code,
            id_card: this.reset.id_card,
            frist_name: this.reset.frist_name,
            last_name: this.reset.last_name,
            brith_day: this.reset.brith_day,
            brith_month: this.reset.brith_month,
            brith_year: this.reset.brith_year,
            tel_p: this.reset.tel_p,
            e_mail: this.reset.e_mail
          });

          let res = result.data;
          if (res.status === "success") {
            this.dialogReset = false;
            this.dialog = true;
            this.dialog_msg = res.message;
            this.$refs.resetForm.reset();
          } else {
            this.dialog = true;
            this.dialog_msg = res.message || "ไม่สามารถรีเซ็ตรหัสผ่านได้";
          }
        } catch (error) {
          this.dialog = true;
          this.dialog_msg = "เกิดข้อผิดพลาดในการรีเซ็ตรหัสผ่าน";
        } finally {
          this.resetLoading = false;
        }
      }
    },

    async userEtcLogin() {
      if (this.$refs.form_etc.validate()) {
        this.loading = true;
        try {
          let result = await this.$http.post("login_etc.php?crud=user", {
            personnel_etc_id_card: this.personnel_etc_id_card,
            personnel_etc_pass: this.personnel_etc_pass
          });

          if (result.data.personnel_etc_m_type) {
            let user = result.data;
            user.system_lock = false;
            sessionStorage.setItem("user", JSON.stringify(user));

            if (
              user.personnel_etc_m_type == "governmentteach" ||
              user.personnel_etc_m_type == "governmentsp" ||
              user.personnel_etc_m_type == "government" ||
              user.personnel_etc_m_type == "governmentjob"
            ) {
              this.dialog = true;
              this.dialog_msg = "เข้าสู่ระบบสำเร็จ กำลังเปลี่ยนหน้า...";
              setTimeout(() => {
                this.$router.push("/userEtc");
              }, 1500);
            } else {
              sessionStorage.clear();
              this.dialog = true;
              this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
            }
          }
        } catch (error) {
          this.dialog = true;
          this.dialog_msg = "เกิดข้อผิดพลาดในการเข้าสู่ระบบ";
        } finally {
          this.loading = false;
        }
      }
    }
  },
  computed: {
    color() {
      return "green lighten-1";
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@300;400;500;600;700;800&display=swap");

.text_google {
  font-family: "Kanit", sans-serif;
}

/* Main Container */
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
  padding: 20px 0;
}

.min-height-screen {
  min-height: 100vh;
}

/* Floating Background Shapes */
.floating-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 80px;
  height: 80px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 120px;
  height: 120px;
  top: 70%;
  right: 10%;
  animation-delay: 2s;
}

.shape-3 {
  width: 60px;
  height: 60px;
  top: 30%;
  right: 30%;
  animation-delay: 4s;
}

.shape-4 {
  width: 100px;
  height: 100px;
  bottom: 10%;
  left: 20%;
  animation-delay: 1s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* Main Content */
.main-content {
  position: relative;
  z-index: 1;
}

/* Login Card */
.login-main-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  overflow: hidden;
}

.login-main-card:hover {
  transform: translateY(-5px);
}

/* Header Section */
.login-header-section {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  padding: 40px 20px 20px;
}

/* Logo Section */
.logo-background {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #7cea66, #1c6511);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);
  position: relative;
  overflow: hidden;
}

.logo-background::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: shimmer 3s linear infinite;
}

.logo-image {
  position: relative;
  z-index: 1;
}

/* Text Styles */
.login-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 8px;
}

.login-subtitle {
  color: #7f8c8d;
  font-size: 1.1rem;
}

/* Chips */
.glass-chip {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  background: linear-gradient(135deg, rgba(102, 234, 104, 0.8), rgba(79, 162, 75, 0.8)) !important;
}

.glass-chip-example {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(23, 162, 184, 0.5) !important;
  background: rgba(23, 162, 184, 0.1) !important;
}

/* Login Button */
.login-btn {
  background: linear-gradient(135deg, #7cea66 0%, #1c6511 100%) !important;
  color: white !important;
  font-weight: 600;
  text-transform: none;
  font-size: 1.2rem;
  padding: 20px 40px;
  transition: all 0.3s ease;
  border: none !important;
  min-height: 60px;
}

.login-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.4) !important;
}

/* Forgot password link */
.forgot-link {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0;
}

/* Field group label inside reset dialog */
.field-group-label {
  font-weight: 600;
  color: #1c6511;
  margin: 4px 0 8px;
  font-size: 0.95rem;
}

/* Dialog Styles */
.login-dialog {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px);
  overflow: hidden;
}

.dialog-header {
  background: linear-gradient(135deg, #7cea66 0%, #1c6511 100%) !important;
}

.dialog-title-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.dialog-icon-bg {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dialog-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
}

.dialog-header .subtitle {
  font-size: 0.9rem;
  opacity: 0.9;
}

/* Form Styles */
.enhanced-input .v-input__control {
  transition: all 0.3s ease;
}

.enhanced-input:hover .v-input__control {
  transform: translateY(-1px);
}

/* Button Styles */
.submit-btn {
  background: linear-gradient(135deg, #7cea66 0%, #1c6511 100%) !important;
  color: white !important;
  font-weight: 600;
  text-transform: none;
}

.cancel-btn {
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: rgba(0, 0, 0, 0.05) !important;
}

/* Quick Stats */
.stat-item {
  transition: all 0.3s ease;
  background: rgba(102, 126, 234, 0.05) !important;
  border: 1px solid rgba(102, 126, 234, 0.1);
}

.stat-item:hover {
  background: rgba(102, 126, 234, 0.1) !important;
  transform: translateY(-2px);
}

.stat-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
}

.stat-label {
  font-size: 0.9rem;
  color: #7f8c8d;
}

/* Enhanced Snackbar */
.enhanced-snackbar .v-snack__wrapper {
  background: linear-gradient(135deg, #7cea66 0%, #1c6511 100%) !important;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

.fade-in-up {
  animation: fadeInUp 1s ease-out both;
}

/* Responsive Design */
@media (max-width: 960px) {
  .login-title {
    font-size: 1.8rem;
  }

  .login-subtitle {
    font-size: 1rem;
  }

  .logo-background {
    width: 100px;
    height: 100px;
  }

  .login-btn {
    font-size: 1.1rem;
    padding: 16px 32px;
  }

  .login-header-section {
    padding: 30px 15px 15px;
  }
}

@media (max-width: 600px) {
  .login-title {
    font-size: 1.6rem;
  }

  .logo-background {
    width: 90px;
    height: 90px;
  }

  .glass-chip {
    font-size: 0.8rem;
    margin: 2px !important;
  }

  .login-header-section {
    padding: 20px 10px 10px;
  }

  .login-btn {
    font-size: 1rem;
    min-height: 50px;
  }
}
</style>